import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {take} from 'rxjs/operators';
import {Router} from '@angular/router';
import {SnackBarService} from '@core/services/snack-bar.service';
import {ParticleCacheService} from '@core/services/particle-cache.service';
import {
  Dynamic_Grid_Data_Request_Parameters,
  User_Specefic_Grid_Filter
} from '@shared/store/actions/virtual-grid.actions';

@Injectable({
  providedIn: 'root'
})
export class PauseResumeOicWorkFlowsCommandHandler implements IPlatformCommandHandler {
  constructor(public commandService: CommandService,
              public router: Router,
              private dialogService: DialogService,
              public fuseSplashScreenService: FuseSplashScreenService,
              public snackBarService: SnackBarService,
              private particleCacheService: ParticleCacheService) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const oicReturnFilterOptions = command.fieldValues['OicReturnFilterOptions'];
    const sourceType = command.fieldValues['SourceType'];
    const parametersObject = this.particleCacheService.getUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, sourceType);
    const fieldSectionId = parametersObject['FIELD_SECTION_ID'];
    const filtersObject = this.particleCacheService.getUserPreferenceGridSetting(User_Specefic_Grid_Filter, sourceType);
    const filters = Object.values(filtersObject);
    const input = {
      oicReturnFilterOptions: oicReturnFilterOptions
    };
    const dialogModel: DialogModel = DialogModel.create(
      command.title,
      'PauseResumeOicWorkflowDialogComponent',
      input,
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
      if (res.action === 'OK') {
        console.log('OK button clicked!');

        const selectedFilterOption = res.data.input['selectedFilterOption'];

        command.fieldValues['ReturnsFilterOption'] = selectedFilterOption;
        command.fieldValues['GridFilter'] = filters;
        command.fieldValues['FIELD_SECTION_ID'] = fieldSectionId;
        this.executeCommandToApi(command, handler);
      }
    });
    return true;
  }

  executeCommandToApi(command: PlatformCommand, handler: IPlatformToolHandler) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('[PlatformFilterHandler] Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectCommand']) {
            handler.executeCommand(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
            return;
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (handler && handler.invalidateSubject) {
            handler.invalidateSubject.invalidate('Refresh');
          }
        },
        error => {
          this.fuseSplashScreenService.hide();
        });
    }
  }
}
